import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext"; // ✅ Import AuthProvider
import LandingPage from "./pages/LandingPage";
import RestaurantsPage from "./pages/RestaurantsPage";
import MenuPage from "./pages/MenuPage";
import CartPage from "./pages/CartPage";
import Login from "./pages/Login";
import Signup from "./pages/SignupPage";
import PhoneLogin from "./pages/PhoneLogin";

function App() {
  return (
    <AuthProvider> {/* ✅ Wrap the entire app */}
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/phone-login" element={<PhoneLogin />} />
          <Route path="/landing" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/restaurants" element={<RestaurantsPage />} />
          <Route path="/menu/:id" element={<MenuPage />} />
          <Route path="/cart" element={<CartPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
